/**
 * These are the states the activity can be in
 * @enum {number}
 */

export enum ActivityStateEnum {
  INVALID = -1,
  PRE_START_SCREEN,
  START,
  SELF_RATE,
  VIDEO,
  SUCCESS_CRITERIA,
  QUESTION,
  RESULTS,
  EXIT_SURVEY,
}
